import Quill from "quill"
var Embed = Quill.import("blots/embed")
const ATTRIBUTES = ["data-id", "data-label", "contenteditable"]

/**
 * Placeholder format for Quill
 */
export default class Placeholder extends Embed {
	static blotName = "placeholder"
	static tagName = "span"
	static className = "ql-placeholder-content"

	domNode!: HTMLImageElement;

	static create (value: any) {
		let node = super.create(value)

		node.setAttribute("class", "ql-placeholder-content badge badge-primary")
		node.setAttribute("data-id", value.id)
		node.setAttribute("data-label", value.label)

		node.innerHTML = value.label

		return node
	}

	static value (domNode: Element) {
		return {
			id: domNode.getAttribute("data-id"),
			label: domNode.getAttribute("data-label")
		}
	}

	static getPlaceholderHtml (placeholderId: string, placeholderLabel: string, placeholderColourClass: string = "badge-primary") {
		return `<span contenteditable="false" class="placeholder-content badge ${placeholderColourClass}" data-id="${placeholderId}" data-label="${placeholderLabel}"><span contenteditable="false">${placeholderLabel}</span></span>`
	}
}
